/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingLineItemTypeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("BillingLineItemTypeQueryOperator");
    }

    getFixupPrototypeFunction() { return BillingLineItemTypeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<BillingLineItemTypeQueryOperator>): BillingLineItemTypeQueryOperator {
        let obj = Object.assign(new BillingLineItemTypeQueryOperator(), model);
        BillingLineItemTypeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingLineItemTypeQueryOperator>): BillingLineItemTypeQueryOperator {
        if (!model) return null;
        return BillingLineItemTypeQueryOperator.newInstance(<BillingLineItemTypeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingLineItemTypeQueryOperator) {
        if (!obj) return;

        models.BillingLineItemTypeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingLineItemTypeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingLineItemTypeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Line Item types to include
     */
    line_item_types: Array<string>;

}
